import { configure, defineRule } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
// eslint-disable-next-line camelcase
import { min, max, required, alpha_num, confirmed } from '@vee-validate/rules'
import {
  dictionary,
  emailAddressValidator,
  phoneNumberValidator,
  passwordValidator,
  idValidator,
  alphaNumeric8CharsValidator,
  headcodeValidator,
  coachLetterValidator,
  seatNumberValidator,
  bookingNumberValidator,
  usernameValidator,
  roleNameValidator,
  textIsOnlyBlanks,
  emailsAddressValidator,
  networkRailDomain,
} from '@utils/validation-rules'

defineRule('booking_number', bookingNumberValidator.validate)
defineRule('seat_number', seatNumberValidator.validate)
defineRule('coach_letter', coachLetterValidator.validate)
defineRule('email_address', emailAddressValidator.validate)
defineRule('password', passwordValidator.validate)
defineRule('phone_number', phoneNumberValidator.validate)
defineRule('id', idValidator.validate)
defineRule('role_name', roleNameValidator.validate)
defineRule('blank_text', textIsOnlyBlanks.validate)
defineRule('alpha_numeric8_chars', alphaNumeric8CharsValidator.validate)
defineRule('headcode', headcodeValidator.validate)
defineRule('username', usernameValidator.validate)
defineRule('emails_address', emailsAddressValidator.validate)
defineRule('network_rail_domain_email', networkRailDomain.validate)
defineRule('min', min)
defineRule('max', max)
defineRule('required', required)
defineRule('alpha_num', alpha_num)
defineRule('confirmed', confirmed)

configure({
  generateMessage: localize({
    en: dictionary,
  }),
})
